import type { ReactNode } from "react";
import "./SchedulePalette.scss";
import classNames from "classnames";
import TopRow from "@/pages/human-resources/time-management/components/schedule-palette/top-row/TopRow.tsx";
import ControlledSearchBar from "@/shared/components/generic/search/ControlledSearchBar.tsx";
import { Size } from "@/shared/components/generic/UiEnums.ts";
import TabSwitcher from "@/pages/human-resources/time-management/components/schedule-palette/TabSwitcher.tsx";
import BottomRow from "@/pages/human-resources/time-management/components/schedule-palette/bottom-row/BottomRow.tsx";
import useTabsState from "@/pages/human-resources/time-management/components/schedule-palette/useTabsState.ts";
import useScheduleViewStateDispatch from "@/pages/human-resources/time-management/model/schedule-view/useScheduleViewStateDispatch.ts";

interface Properties {
  horizontal: boolean;
  onToggleHorizontal: () => void;
}
export default function SchedulePalette(props: Properties): ReactNode {
  const { dispatch } = useScheduleViewStateDispatch();
  const tabState = useTabsState();

  return (
    <div
      className={classNames(
        "schedule-palette",
        props.horizontal && "horizontal",
      )}
    >
      <TopRow
        onViewTypeChange={(vt) => {
          dispatch({ type: "setPaletteView", view: vt });
        }}
        horizontal={props.horizontal}
        onToggleHorizontal={props.onToggleHorizontal}
        searchInput={tabState.searchInput}
        onSearchInputChanged={tabState.setSearchInput}
      />
      {!props.horizontal && (
        <div className="search-bar-wrapper">
          <ControlledSearchBar
            size={Size.SMALL}
            width={"250px"}
            input={tabState.searchInput}
            onInputChanged={tabState.setSearchInput}
            searchOnKeyStroke={true}
            onSearch={tabState.setSearchInput}
          />
        </div>
      )}
      <TabSwitcher
        searchInput={tabState.searchInput}
        horizontal={props.horizontal}
      />
      <BottomRow
        horizontal={props.horizontal}
        settingsPage={tabState.settingsPage}
      />
    </div>
  );
}
